import styled from "styled-components";


export const GridContainer = styled.div`
height: 110%;
`

export const TableTheme = {
    color: "whiteSmoke", borderColor: "#614e20ff", borderTop: "2px solid #614e20ff",
    borderBottom: "2px solid #614e20ff", fontSize: "14px", borderRadius: "0px",

    "& .MuiDataGrid-columnHeaderTitleContainer": {
        fontSize: "14px",
        BackgroundColor: "#081019ff !important",

    },
    '& .MuiDataGrid-columnSeparator':{
        display:"none"
    },
    "& .MuiDataGrid-row": {
        borderColor: "#614e20ff !important",
    },

    "& .css-rtrcn9-MuiTablePagination-root": {
        color: "whiteSmoke !important",
        display:"none !important"
    },

    "& .MuiButtonBase-root": {
        color: "whiteSmoke !important",
    },

    "& .MuiDataGrid-cell": {
        borderColor: "#614e20ff"
    },

    "& .MuiDataGrid-cell:focus": {
        outline: "none !important",
    }

}